export const fields = {
    note: {
      label: "Add A Note",
      type: "text",
      rules: "required|string",
    },
  };